module.exports = __webpack_public_path__ + "static/media/lTFinance.0443f646.svg";